'use client';

import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { useProjects } from '../context/ProjectContext';
import ProjectPickerModal from './ProjectPickerModal';

/**
 * Blocks children unless there is an active project.
 * If user cancels without picking, they get redirected home.
 */
export default function RequireProject({ children }) {
    const { activeProjectName } = useProjects();
    const router = useRouter();

    // Don’t even try server-side. Keep it client-only and quiet.
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);

    const needPick = useMemo(() => mounted && !activeProjectName?.trim(), [mounted, activeProjectName]);

    if (!mounted) return null;

    return (
        <>
            {!needPick && children}

            {needPick && (
                <ProjectPickerModal
                    open
                    onClose={() => {
                        // If they still don’t have a project after closing, bail out to home.
                        if (!activeProjectName?.trim()) router.push('/');
                    }}
                />
            )}
        </>
    );
}
